import React, { useEffect, useState } from 'react';
import { fmtDate } from '../../lib/dates';
import { useAuth } from '../../context/AuthContext';
import { Gavel, User } from 'lucide-react';

const STATUS = { open: 'Abierto', in_progress: 'En curso', pending: 'Pendiente', closed_won: 'Ganado', closed_lost: 'Perdido', closed: 'Cerrado' };

export const AdminCRMView = () => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    api.get('/admin/crm/matters').then((r) => setData(r.data)).catch((e) => setError(e.response?.data?.detail || 'No se pudieron cargar los casos'));
  }, [api]);
  if (error) return <p data-testid="admin-crm-error" className="text-red-400">{error}</p>;
  if (!data) return <p className="text-slate-400">Cargando casos de todos los usuarios...</p>;
  return (
    <div data-testid="admin-crm-view">
      <p className="text-sm text-slate-400 mb-4">{data.total} caso(s) de {data.users_with_cases} usuario(s) · solo lectura</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.matters.map((m) => (
          <div key={m.id} data-testid={`admin-matter-${m.id}`} className="bg-slate-900/60 border border-slate-700 rounded-xl p-4">
            <p className="text-white font-semibold truncate">{m.title}</p>
            <p className="text-xs text-slate-400 flex items-center gap-1"><User className="w-3 h-3" />{m.owner_email}</p>
            <p className="text-xs text-slate-400 capitalize">{m.matter_type} · {m.country} · {STATUS[m.status] || m.status}</p>
            <div className="flex justify-between items-center mt-2">
              <p className="text-sm text-slate-300 flex items-center gap-1 truncate"><Gavel className="w-3 h-3 text-amber-400" />{m.assigned_judge_name || 'Sin juez'}</p>
              <p className="text-lg font-bold text-amber-400">{typeof m.ai_win_probability === 'number' ? `${Math.round(m.ai_win_probability * 100)}%` : '—'}</p>
            </div>
            {m.next_hearing && <p className="text-xs text-cyan-300 mt-1">Audiencia: {fmtDate(m.next_hearing, true)}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
